<div>
	<h2>Set Administrators</h2>
	<div fxLayout fxLayoutAlign="start center" class="mb-2 mt-xs">
		<mat-form-field fxFlex="53%">
			<input matInput type="text" placeholder="Filter" [(ngModel)]="filterText" (keyup)="filterEmployees()" />
			<button
				mat-icon-button
				matSuffix
				*ngIf="filterText"
				[attr.aria-label]="'Clear'"
				(click)="filterText = ''; filterEmployees()"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
	</div>
	<mat-dialog-content>
		<table mat-table class="pilot-table" [dataSource]="employees">
			<ng-container matColumnDef="firstName">
				<th class="name-cell" mat-header-cell *matHeaderCellDef>First Name</th>
				<td mat-cell *matCellDef="let employee">{{ employee.firstName }}</td>
			</ng-container>

			<ng-container matColumnDef="lastName">
				<th class="name-cell" mat-header-cell *matHeaderCellDef>Last Name</th>
				<td mat-cell *matCellDef="let employee">{{ employee.lastName }}</td>
			</ng-container>

			<ng-container matColumnDef="emailAddress">
				<th class="name-cell" mat-header-cell *matHeaderCellDef>Email Address</th>
				<td mat-cell *matCellDef="let employee">{{ employee.emailAddress }}</td>
			</ng-container>

			<ng-container matColumnDef="isAdmin">
				<th mat-header-cell *matHeaderCellDef>Is Administrator</th>
				<td mat-cell *matCellDef="let employee">
					<mat-slide-toggle
						[checked]="employee.isAdmin"
						(change)="adminStateChanged(employee)"
						color="primary"
					></mat-slide-toggle>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="['firstName', 'lastName', 'emailAddress', 'isAdmin']; sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: ['firstName', 'lastName', 'emailAddress', 'isAdmin']"></tr>
		</table>

		<div *ngIf="isLoading" class="loading-container"></div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayoutAlign="end end">
		<button class="mat-raised-button" (click)="close()">Close</button>
	</mat-dialog-actions>
</div>
